import React, { useRef } from "react";
import {
  faFacebook,
  faGithub,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import LogoYA from "../img/png/logo.png";
import "./Menu.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Menu() {
  let projectOptions = useRef(null);
  let socialOptions = useRef(null);
  let menuPos = useRef(null);
  let body = document.querySelector("body");

  let language = localStorage.getItem("language");

  function displayOptionsProjects(e) {
    if (projectOptions.current.style.display === "none") {
      projectOptions.current.style.display = "block";
      socialOptions.current.style.display = "none";
      projectOptions.current.style.animation = "appearList .5s";
    } else {
      projectOptions.current.style.animation = "disappearList .5s";
      setTimeout(() => {
        projectOptions.current.style.display = "none";
      }, 500);
    }
  }
  body.addEventListener("keypress", (e) => {
    if (e.key) {
      projectOptions.current.style.display = "none";
      socialOptions.current.style.display = "none";
    }
  });

  function displaySocialProjects() {
    if (socialOptions.current.style.display === "none") {
      socialOptions.current.style.display = "block";
      projectOptions.current.style.display = "none";
      socialOptions.current.style.animation = "appearList .5s";
    } else {
      socialOptions.current.style.animation = "disappearList .5s";
      setTimeout(() => {
        socialOptions.current.style.display = "none";
      }, 500);
    }
  }
  return (
    <div className="menu-top" ref={menuPos}>
      <div className="menu-top__logo">
        <img src={LogoYA} alt="Yojhan Atuesta" />
      </div>
      <ul className="menu-top__items">
        <li
          className="menu-top__items-option"
          style={language === "english" ? {} : { display: "none" }}
        >
          <Link to="/">Home</Link>
        </li>
        <li
          className="menu-top__items-option"
          style={language === "español" || !language ? {} : { display: "none" }}
        >
          <Link to="/">Inicio</Link>
        </li>
        <li
          className="menu-top__items-option"
          onClick={displayOptionsProjects}
          style={language === "english" ? {} : { display: "none" }}
        >
          Projects
        </li>
        <li
          className="menu-top__items-option"
          onClick={displayOptionsProjects}
          style={language === "español" || !language ? {} : { display: "none" }}
        >
          Proyectos
        </li>
        <li
          className="menu-top__items-option"
          style={language === "english" ? {} : { display: "none" }}
        >
          <Link to="/contact">Contact</Link>
        </li>
        <li
          className="menu-top__items-option"
          style={language === "español" || !language ? {} : { display: "none" }}
        >
          <Link to="/contact">Contacto</Link>
        </li>
        <li
          className="menu-top__items-option-social"
          onClick={displaySocialProjects}
        >
          Social
        </li>
      </ul>
      <ul
        className="menu-top__hover-items-projects"
        ref={projectOptions}
        style={{ display: "none" }}
      >
        <li className="menu-top__hover-items-option">
          <Link to="/personal">Personal page </Link>
        </li>
        <li className="menu-top__hover-items-option">
          <Link to="/webapp">WebApp fullstack</Link>
        </li>
        <li className="menu-top__hover-items-option">
          <Link to="/eshop">eShop SPA</Link>
        </li>
      </ul>

      <ul
        className="menu-top__hover-items-social"
        ref={socialOptions}
        style={{ display: "none" }}
      >
        <li className="menu-top__hover-items-option">
          <a
            href="https://www.facebook.com/yojhan.atuesta/"
            target="_blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faFacebook} /> Facebook
          </a>
        </li>

        <li className="menu-top__hover-items-option">
          <a
            href="https://github.com/RAdvelopment"
            target="blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faGithub} /> GitHub
          </a>
        </li>
        <li className="menu-top__hover-items-option">
          <a
            href="https://www.linkedin.com/in/yojhan-atuesta-355690206/"
            target="blank"
            rel="noreferrer"
          >
            <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
          </a>
        </li>
      </ul>
    </div>
  );
}
